<template>
  <div>
    <!-- <a-form layout="inline" :model="seekData" class="ant-advanced-search-form">
      <a-form-item label="提交时间">
        <a-range-picker
          v-model="seekData.time"
          valueFormat="YYYY-MM-DD"
          :placeholder="['请选择日期', '请选择日期']"
        />
      </a-form-item>
      <a-form-item>
        <a-button class="mr10" type="primary" icon="search" @click="doSeek">
          查询
        </a-button>
        <a-button @click="removeSeek" icon="reload"> 重置 </a-button>
      </a-form-item>
    </a-form> -->

    <!-- el版 -->
    <el-form :inline="true" ref="seekData" :model="seekData" class="ant-advanced-search-form">
      <el-form-item label="提交时间">
        <el-date-picker v-model="seekData.time" type="datetimerange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="doSeek" icon="el-icon-search">查询</el-button>
        <el-button icon="el-icon-refresh" type="" @click="removeSeek('seekData')">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="wz-mt-2">
      <!-- <a-table
        bordered
        @change="tableChange"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :rowKey="
          (record, index) => {
            return index;
          }
        "
      >
        <template slot="action" slot-scope="text, record">
          <a-button type="primary" size="small" @click="goInfo(record)"
            >详情</a-button
          >
        </template>
</a-table> -->

      <el-table element-loading-text="加载中" :data="list" border style="width: 100%">
        <el-table-column label="编号" align="center" type="index" width="50" />
        <el-table-column label="问卷类型" align="center" prop="queType" />
        <el-table-column label="问卷名称" align="center" prop="templateName" />
        <el-table-column label="提交时间" align="center" prop="createTime">
          <template slot-scope="scope">
            <div>
              {{
      scope.row.createTime
        ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss")
        : ""
    }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <div class="">
              <el-button size="small" plain type="primary" @click="goInfo(scope.row)">详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="pagination.total" :page.sync="pagination.current" :limit.sync="pagination.pageSize"
        @pagination="getList" />
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { message } from "ant-design-vue";
import * as API_Member from "@/api/member/member";
const columns = [
  {
    title: "编号",
    dataIndex: "index",
    key: "index",
    align: "center",
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "问卷类型",
    dataIndex: "queType",
    align: "center",
    key: "queType",
  },
  {
    title: "问卷名称",
    dataIndex: "templateName",
    align: "center",
    key: "templateName",
  },
  {
    title: "提交时间",
    dataIndex: "createTime",
    key: "createTime",
    align: "center",
    customRender: function (val) {
      return val ? moment(val).format("YYYY-MM-DD HH:mm:ss") : "";
    },
  },
  {
    title: "操作",
    width: 150,
    dataIndex: "action",
    key: "action",
    fixed: "right",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];

export default {
  components: {},
  inject: ["getId"],
  computed: {
    id() {
      return this.getId();
    },
  },
  data() {
    return {
      columns: columns,
      list: [],
      //数据分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        total: 100,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        showTotal: (total) => `共有${total}数据`,
      },

      seekData: {
        time: [], // 注册时间
      },
      doSeekData: {
        startTime: null, // 时间-开始
        endTime: null, // 时间-结束
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    moment,
    goInfo(item) {
      this.$router.push({
        name: "questionEnd",
        query: {
          templateId: this.id,
          questionTitle: item.templateName,
          queBatch: item.queBatch
        },
      });
      // console.log("详情--", item);
      // this.$router.push('questionEnd?templateId=' + this.id + '&questionTitle=' + item.templateName + '&queBatch=' + item.queBatch);
    },
    // 切换页数
    tableChange(e) {
      this.pagination.current = e.current;
      this.getList();
    },
    // 点击搜索
    doSeek() {
      Object.keys(this.seekData).forEach((key) => {
        if (key != "time") {
          this.doSeekData[key] = this.seekData[key];
        }
      });
      if (this.seekData.time.length > 0) {
        this.doSeekData.startTime = moment(this.seekData.time[0]).valueOf();
        this.doSeekData.endTime = moment(this.seekData.time[1]).valueOf();
      } else {
        this.doSeekData.startTime = null;
        this.doSeekData.endTime = null;
      }

      this.pagination.current = 1;
      this.getList();
    },
    // 重置
    removeSeek() {
      Object.keys(this.seekData).forEach((key) => {
        if (key != "time") {
          this.seekData[key] = null;
        } else {
          this.seekData[key] = [];
        }
      });
      Object.keys(this.doSeekData).forEach((key) => {
        if (key != "time") {
          this.doSeekData[key] = null;
        } else {
          this.doSeekData[key] = [];
        }
      });
      this.pagination.current = 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      const getData = await API_Member.getQueDay({
        memberId: this.id,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.doSeekData,
      });
      if (getData.code == 200) {
        this.pagination.total = getData.data.total;
        this.list = getData.data.list;
      }
    },
  },
};
</script>
<style scoped lang="less">
::v-deep.ant-table-body table {
  border: none;
}

.ant-advanced-search-form {
  padding: 24px;
  // background: #fbfbfb;
  // border-radius: 6px;
}
</style>
